export default __webpack_public_path__ + "static/Procurement-f56127c317ce6574d1d2464c661c8ac5.png";